import React from 'react';
import { useTranslation } from 'react-i18next';
import IconParagraph from '../IconParagraph';

const EuGoals = () => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');

  return (
    <div className="stack">
      <h2>{tHelpAndSupport('commonQuestions.GoalAchievement.EU')}</h2>
      <IconParagraph header={tHelpAndSupport('commonQuestions.GoalAchievement.EU.1')}>
        <p>{tHelpAndSupport('commonQuestions.GoalAchievement.EU.1.Text')}</p>
      </IconParagraph>
      <IconParagraph header={tHelpAndSupport('commonQuestions.GoalAchievement.EU.2')}>
        <p>{tHelpAndSupport('commonQuestions.GoalAchievement.EU.2.Text')}</p>
      </IconParagraph>
      <IconParagraph header={tHelpAndSupport('commonQuestions.GoalAchievement.EU.3')}>
        <p>{tHelpAndSupport('commonQuestions.GoalAchievement.EU.3.Text')}</p>
      </IconParagraph>
      <IconParagraph header={tHelpAndSupport('commonQuestions.GoalAchievement.EU.4')}>
        <p>{tHelpAndSupport('commonQuestions.GoalAchievement.EU.4.Text')}</p>
      </IconParagraph>
      <IconParagraph header={tHelpAndSupport('commonQuestions.GoalAchievement.EU.5')}>
        <p>{tHelpAndSupport('commonQuestions.GoalAchievement.EU.5.Text')}</p>
      </IconParagraph>
      <IconParagraph header={tHelpAndSupport('commonQuestions.GoalAchievement.EU.6')}>
        <p>{tHelpAndSupport('commonQuestions.GoalAchievement.EU.6.Text')}</p>
      </IconParagraph>
      <IconParagraph header="Vurdering av (potensiell) vesentlig positiv effekt">
        <p>
          Vurdering av (potensiell) vesentlig positiv effekt I vurderingen av bedriftens (potensielle)
          positive vesentlige effekt skal følgende aspekter inkluderes:
          <ul>
            <li>
              <b>Den forventede positive miljøeffekten er vesentlig.</b>
              <br /> Med vesentlig menes at det kan underbygges at bedriften legger til rette for og/eller
              realiserer nye løsninger innenfor en eller flere av miljøkategoriene. Tommelfingerregel: ca
              10-20% forbedring sammenliknet med bransjestandard. Bedrifter der miljøeffekten er svært
              indirekte og usikker skal ikke klassifiseres til å ha en vesentlig positiv miljøeffekt. Det er
              heller ikke tilstrekkelig at bedriften «ikke gjør skade», eller at den ellers har stor
              samfunnsmessig betydning, for at den skal kunne klassifiseres til å ha en vesentlig positiv
              miljøeffekt.
            </li>
            <li>
              <b>
                Kravet om vesentlighet kan også tilfredsstilles gjennom at bedriften gjør det direkte mulig
                for annen økonomisk aktivitet å gi et vesentlig bidrag til minst én av miljøkategoriene.
              </b>
              <br /> Dette forutsetter at det samtidig ikke fører til teknologisk innlåsing av løsninger som
              ikke er forenlig med miljøkategoriene.
            </li>
            <li>
              <b>Bedrifter vil ha ulik grad av modenhet.</b>
              <br /> For bedrifter med innovasjonsaktiviteter i tidlig fase vurderes den potensielle positive
              miljøeffekten. Her kan det forutsettes at bedriften lykkes med sine planer og at løsningene tas
              i bruk.
            </li>
            <li>
              <b>Det skal være en rimelig sammenheng mellom forventet resultat og miljøeffekten.</b>
              <br /> Dersom det er mange forutsetninger – i tillegg til realiseringen av bedriftens planlagte
              løsninger – som må innfris for at miljøeffekten skal kunne realiseres, anses den forventede
              effekten å være liten, og bedriften skal ikke vurderes å gi vesentlig positiv miljøeffekt.
            </li>
          </ul>
          <b>Vurdering av potensiell vesentlig negativ effekt</b>
          <br />
          For at en bedrift skal anses å ha vesentlig negativ effekt på miljømålene, må den forårsake
          betydelig skade på noen av de seks miljømålene: <br />
          <b>Klimagassutslipp:</b> Bidra til betydelige klimagassutslipp. <br />
          <b>Klimatilpasning:</b> Utgjøre/medføre en betydelig risiko for klimaendringer.
          <br /> <b>Bærekraftig bruk og beskyttelse av vann- og marine ressurser: </b>
          Forringe vannkvaliteten eller økosystemer betydelig. <br />
          <b>Omstilling til en sirkulær økonomi:</b> Føre til betydelig økt avfallsmengde og ressursbruk.{' '}
          <br />
          <b>Forebygging og kontroll av forurensning:</b> Forårsake betydelig økning av forurensning i luft,
          vann eller jord.
          <br /> <b>Verne om og restaurere naturmangfold og økosystemer:</b> Gjøre betydelig skade på
          økosystemers tilstand og motstandskraft.
        </p>
      </IconParagraph>
    </div>
  );
};

export default EuGoals;
